import { render, staticRenderFns } from "./ActCancelBtn.vue?vue&type=template&id=2ce2b054"
import script from "./ActCancelBtn.vue?vue&type=script&lang=js"
export * from "./ActCancelBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports